/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateUserLevelBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllUserLevelsResponse } from '../models';
// @ts-ignore
import type { MyLadderResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateUserLevelBody } from '../models';
// @ts-ignore
import type { UploadUserLevelImageResponse } from '../models';
// @ts-ignore
import type { UserLevelResponse } from '../models';
/**
 * UserLevelApiApi - axios parameter creator
 */
export const UserLevelApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserLevelBody} createUserLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiCreateUserLevel: async (createUserLevelBody: CreateUserLevelBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserLevelBody' is not null or undefined
            assertParamExists('userLevelApiCreateUserLevel', 'createUserLevelBody', createUserLevelBody)
            const localVarPath = `/user-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserLevelBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiDeleteUserLevel: async (levelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'levelId' is not null or undefined
            assertParamExists('userLevelApiDeleteUserLevel', 'levelId', levelId)
            const localVarPath = `/user-level/{level_id}`
                .replace('{level_id}', encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiGetAllUserLevels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiGetMyUserLevel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-level/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiGetUserLevelById: async (levelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'levelId' is not null or undefined
            assertParamExists('userLevelApiGetUserLevelById', 'levelId', levelId)
            const localVarPath = `/user-level/{level_id}`
                .replace('{level_id}', encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} levelId 
         * @param {UpdateUserLevelBody} updateUserLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiUpdateUserLevel: async (levelId: string, updateUserLevelBody: UpdateUserLevelBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'levelId' is not null or undefined
            assertParamExists('userLevelApiUpdateUserLevel', 'levelId', levelId)
            // verify required parameter 'updateUserLevelBody' is not null or undefined
            assertParamExists('userLevelApiUpdateUserLevel', 'updateUserLevelBody', updateUserLevelBody)
            const localVarPath = `/user-level/{level_id}`
                .replace('{level_id}', encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserLevelBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiUploadUserLevelImage: async (image: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('userLevelApiUploadUserLevelImage', 'image', image)
            const localVarPath = `/user-level/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserLevelApiApi - functional programming interface
 */
export const UserLevelApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserLevelApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserLevelBody} createUserLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiCreateUserLevel(createUserLevelBody: CreateUserLevelBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiCreateUserLevel(createUserLevelBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiCreateUserLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiDeleteUserLevel(levelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiDeleteUserLevel(levelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiDeleteUserLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiGetAllUserLevels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllUserLevelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiGetAllUserLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiGetAllUserLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiGetMyUserLevel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyLadderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiGetMyUserLevel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiGetMyUserLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiGetUserLevelById(levelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiGetUserLevelById(levelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiGetUserLevelById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} levelId 
         * @param {UpdateUserLevelBody} updateUserLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiUpdateUserLevel(levelId: string, updateUserLevelBody: UpdateUserLevelBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiUpdateUserLevel(levelId, updateUserLevelBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiUpdateUserLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLevelApiUploadUserLevelImage(image: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUserLevelImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLevelApiUploadUserLevelImage(image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserLevelApiApi.userLevelApiUploadUserLevelImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserLevelApiApi - factory interface
 */
export const UserLevelApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserLevelApiApiFp(configuration)
    return {
        /**
         * 
         * @param {UserLevelApiApiUserLevelApiCreateUserLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiCreateUserLevel(requestParameters: UserLevelApiApiUserLevelApiCreateUserLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserLevelResponse> {
            return localVarFp.userLevelApiCreateUserLevel(requestParameters.createUserLevelBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserLevelApiApiUserLevelApiDeleteUserLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiDeleteUserLevel(requestParameters: UserLevelApiApiUserLevelApiDeleteUserLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.userLevelApiDeleteUserLevel(requestParameters.levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiGetAllUserLevels(options?: RawAxiosRequestConfig): AxiosPromise<GetAllUserLevelsResponse> {
            return localVarFp.userLevelApiGetAllUserLevels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiGetMyUserLevel(options?: RawAxiosRequestConfig): AxiosPromise<MyLadderResponse> {
            return localVarFp.userLevelApiGetMyUserLevel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserLevelApiApiUserLevelApiGetUserLevelByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiGetUserLevelById(requestParameters: UserLevelApiApiUserLevelApiGetUserLevelByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserLevelResponse> {
            return localVarFp.userLevelApiGetUserLevelById(requestParameters.levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserLevelApiApiUserLevelApiUpdateUserLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiUpdateUserLevel(requestParameters: UserLevelApiApiUserLevelApiUpdateUserLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserLevelResponse> {
            return localVarFp.userLevelApiUpdateUserLevel(requestParameters.levelId, requestParameters.updateUserLevelBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserLevelApiApiUserLevelApiUploadUserLevelImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLevelApiUploadUserLevelImage(requestParameters: UserLevelApiApiUserLevelApiUploadUserLevelImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadUserLevelImageResponse> {
            return localVarFp.userLevelApiUploadUserLevelImage(requestParameters.image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userLevelApiCreateUserLevel operation in UserLevelApiApi.
 */
export interface UserLevelApiApiUserLevelApiCreateUserLevelRequest {
    readonly createUserLevelBody: CreateUserLevelBody
}

/**
 * Request parameters for userLevelApiDeleteUserLevel operation in UserLevelApiApi.
 */
export interface UserLevelApiApiUserLevelApiDeleteUserLevelRequest {
    readonly levelId: string
}

/**
 * Request parameters for userLevelApiGetUserLevelById operation in UserLevelApiApi.
 */
export interface UserLevelApiApiUserLevelApiGetUserLevelByIdRequest {
    readonly levelId: string
}

/**
 * Request parameters for userLevelApiUpdateUserLevel operation in UserLevelApiApi.
 */
export interface UserLevelApiApiUserLevelApiUpdateUserLevelRequest {
    readonly levelId: string

    readonly updateUserLevelBody: UpdateUserLevelBody
}

/**
 * Request parameters for userLevelApiUploadUserLevelImage operation in UserLevelApiApi.
 */
export interface UserLevelApiApiUserLevelApiUploadUserLevelImageRequest {
    readonly image: File
}

/**
 * UserLevelApiApi - object-oriented interface
 */
export class UserLevelApiApi extends BaseAPI {
    /**
     * 
     * @param {UserLevelApiApiUserLevelApiCreateUserLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiCreateUserLevel(requestParameters: UserLevelApiApiUserLevelApiCreateUserLevelRequest, options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiCreateUserLevel(requestParameters.createUserLevelBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserLevelApiApiUserLevelApiDeleteUserLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiDeleteUserLevel(requestParameters: UserLevelApiApiUserLevelApiDeleteUserLevelRequest, options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiDeleteUserLevel(requestParameters.levelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiGetAllUserLevels(options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiGetAllUserLevels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiGetMyUserLevel(options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiGetMyUserLevel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserLevelApiApiUserLevelApiGetUserLevelByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiGetUserLevelById(requestParameters: UserLevelApiApiUserLevelApiGetUserLevelByIdRequest, options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiGetUserLevelById(requestParameters.levelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserLevelApiApiUserLevelApiUpdateUserLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiUpdateUserLevel(requestParameters: UserLevelApiApiUserLevelApiUpdateUserLevelRequest, options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiUpdateUserLevel(requestParameters.levelId, requestParameters.updateUserLevelBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserLevelApiApiUserLevelApiUploadUserLevelImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userLevelApiUploadUserLevelImage(requestParameters: UserLevelApiApiUserLevelApiUploadUserLevelImageRequest, options?: RawAxiosRequestConfig) {
        return UserLevelApiApiFp(this.configuration).userLevelApiUploadUserLevelImage(requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }
}

